/**
 * NewLogin selectors
 */

import { createSelector } from 'reselect';
import { NEW_LOGIN_REDUCER } from './constants';
import { REQUEST } from '../App/constants';

const selectNewLoginDomain = (state) => state.get(NEW_LOGIN_REDUCER);

/**
 * Default selector used by NewLogin
 */
export const makeSelectLoginV2 = () =>
  createSelector(selectNewLoginDomain, (substate) => ({
    isLoading: substate.get('loginV2Status') === REQUEST,
    error: substate.get('loginV2Error'),
    loginV2Status: substate.get('loginV2Status'),
    showPasswordField: substate.get('showPasswordField'),        
    checkingSsoDomain: substate.get('checkingSsoDomain'),        
    email: substate.get('email'),                                
  }));

/**
 * Selector for OTP validation state
 */
export const makeSelectValidateOTP = () =>
  createSelector(selectNewLoginDomain, (substate) => ({
    isLoading: substate.get('validateOTPStatus') === REQUEST,
    error: substate.get('validateOTPError'),
    validateOTPStatus: substate.get('validateOTPStatus'),
  }));

/**
 * Selector for OTP resend state
 */
export const makeSelectResendOTP = () =>
  createSelector(selectNewLoginDomain, (substate) => ({
    isLoading: substate.get('resendOTPStatus') === REQUEST,
    error: substate.get('resendOTPError'),
    resendOTPStatus: substate.get('resendOTPStatus'),
  }));

/**
 * Selector for forgot password state
 */
export const makeSelectForgotPassword = () =>
  createSelector(selectNewLoginDomain, (substate) => ({
    isLoading: substate.get('forgotPasswordStatus') === REQUEST,
    error: substate.get('forgotPasswordError'),
    forgotPasswordStatus: substate.get('forgotPasswordStatus'),
  }));

/**
 * Selector for set password state
 */
export const makeSelectSetPassword = () =>
  createSelector(selectNewLoginDomain, (substate) => ({
    isLoading: substate.get('setPasswordStatus') === REQUEST,
    error: substate.get('setPasswordError'),
    setPasswordStatus: substate.get('setPasswordStatus'),
  }));

export const makeSelectOtpSessionGuard = () =>
  createSelector(selectNewLoginDomain, (substate) => substate.get('otpSessionGuard'));
